export default __webpack_public_path__ + "static/media/infectious_decay_model.800e48c3.png";